export default __webpack_public_path__ + "static/notSure-f99fdd532803346cec5b558871713a2a.svg";